import { API_BASE_URLS } from '../config/api.config';

const BASE_PATH = '/order-agent';

const getBackendUrl = () => {
  const baseUrl = API_BASE_URLS.aiServices || '';
  return baseUrl.replace(/\/$/, '');
};
const getDataTriageUrl = () => {
  const baseUrl = API_BASE_URLS.dataTriage || '';
  return baseUrl.replace(/\/$/, '');
}
const buildAIUrl = (path = '') => {
  return `${getBackendUrl()}${BASE_PATH}${path}`;
};
const buildAIUrlWithoutBase = (path = '') => {
  return `${getDataTriageUrl()}${path}`;
};

export const AI_ENDPOINTS = {
  CHAT: buildAIUrl('/query'),
  HEALTH_CHECK: buildAIUrl('/health'),
  GET_FILE_DATA_TRIAGE: (orderId) => buildAIUrlWithoutBase(`/file-data-triage/${orderId}`),
  SAVE_DRAFT_DATA: buildAIUrlWithoutBase('/file-data-triage/save-draft'),
  CONFIRM_MAPPINGS: buildAIUrlWithoutBase('/file-data-triage/confirm-mapping'),
};

export default AI_ENDPOINTS;
